import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=2881236f"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports